/**
 * A new chat's id. assistant-ui names a thread it hasn't saved yet `__LOCALID_<7 chars>`, which
 * is only unique in this tab; the object behind a thread is named by its id, so a new chat gets a
 * UUID, the same one `initialize` (use-thread-adapter.ts) later reports as its remote id.
 */
const newThreadIds = new Map<string, string>();
export function threadIdFor(localId: string): string {
  let id = newThreadIds.get(localId);
  if (!id) {
    id = crypto.randomUUID();
    newThreadIds.set(localId, id);
  }
  return id;
}
